<template>
  <div
    class="checkmark-icon"
    @click="onClick"
  >
    <div class="checkmark">
      <img :src="doneButton" alt="" />
    </div>
    <span class="checkmark-text">
      {{ text }}
    </span>
  </div>
</template>

<script>
import doneButton from 'assets/images/activities/hear-it-type-it/doneButton.png';

export default {
  data() {
    return {
      doneButton
    };
  },
  props: {
    text: {
      type: String,
      required: true
    },
    onClick: {
      type: Function,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.checkmark-text {
  display: block;
  color: #109a11;
  letter-spacing: 1px;
  text-align: center;
}
.checkmark img {
  display: block;
  height: auto;
  width: 40px;
}
.checkmark-icon:hover {
  cursor: pointer;
}
</style>
